import { useState } from "react";
import axios from "axios";

const FixedConsultationForm = () => {
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [isAgreed, setIsAgreed] = useState(true); // 기본적으로 체크됨

  const formatPhoneNumber = (value) => {
    value = value.replace(/\D/g, "");
    if (value.length <= 3) return value;
    if (value.length <= 7) return `${value.slice(0, 3)}-${value.slice(3)}`;
    return `${value.slice(0, 3)}-${value.slice(3, 7)}-${value.slice(7, 11)}`;
  };

  const getSelectedValue = (option) => {
    const mapping = {
      일반진료: 1021,
      치아교정: 1022,
      임플란트: 1023,
    };
    return mapping[option] || null;
  };

  const validateForm = () => {
    if (name.length < 2) {
      alert("이름은 최소 2글자 이상 입력해야 합니다.");
      return false;
    }
    if (!/^\d{3}-\d{3,4}-\d{4}$/.test(phoneNumber)) {
      alert("전화번호는 010-0000-0000 형식으로 입력해주세요.");
      return false;
    }
    if (!selectedOption) {
      alert("진료항목을 선택해주세요.");
      return false;
    }
    if (!isAgreed) {
      alert("개인정보 수집 및 이용 동의에 체크해야 합니다.");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const now = new Date();
    const koreaTime = new Date(now.getTime() + 9 * 60 * 60 * 1000)
      .toISOString()
      .replace("Z", "");

    const requestData = {
      name,
      phoneNumber: phoneNumber.replace(/-/g, ""),
      selectedOption,
      date: koreaTime,
      urlCode: "AQG7O4",
      urlCodeSettingId: "1086",
      selectedValue: getSelectedValue(selectedOption),
    };

    try {
      const response = await axios.post(
        "https://funnelslanding.co.kr/api/randing/customer",
        requestData,
        { headers: { "Content-Type": "application/json" } }
      );
      if (response.status === 201) {
        alert("상담 신청이 완료되었습니다.");
        setName("");
        setPhoneNumber("");
        setSelectedOption("");
        setIsAgreed(true);
      } else {
        alert("상담 신청에 실패했습니다.");
      }
    } catch (error) {
      console.error("API 요청 오류:", error);
      alert("서버 오류가 발생했습니다.");
    }
  };

  return (
    <div className="fixed-form">
      <form onSubmit={handleSubmit} className="consultation-form">
        <div className="fastPOST">빠른 상담 신청</div>

        <div className="input-group">
          <input
            type="text"
            placeholder="이름"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="form-input input-name"
          />
          <select
            value={selectedOption}
            onChange={(e) => setSelectedOption(e.target.value)}
            className="form-select"
          >
            <option value="">진료항목</option>
            <option value="일반진료">일반진료</option>
            {/* <option value="치아교정">치아교정</option> */}
            <option value="임플란트">임플란트</option>
          </select>
        </div>

        <input
          type="tel"
          placeholder="연락처"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(formatPhoneNumber(e.target.value))}
          maxLength="13"
          className="form-input input-phone"
        />

        <label className="agreement">
          <input
            type="checkbox"
            checked={isAgreed}
            onChange={() => setIsAgreed(!isAgreed)}
          />
          개인정보 수집 및 이용 동의(자세히보기)
        </label>

        <button type="submit" className="submit-button">
          상담 신청
        </button>
      </form>

      <style jsx>{`
        .fixed-form {
          position: fixed;
          bottom: 0;
          left: 0;
          width: 100%;
          background-color: #2a2725;
          padding: 15px 0;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 10px;
          box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.2);
        }

        .consultation-form {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          gap: 10px;
        }

        .fastPOST {
          color: white;
          font-size: 25px;
          font-weight: 700;
          margin-right: 10px;
        }

        .input-group {
          display: flex;
          gap: 10px;
        }

        .form-input,
        .form-select {
          padding: 0px 10px;
          font-size: 16px;
          border: 1px solid #ccc;
          height: 44px;
        }

        .input-name {
          width: 8vw;
          min-width: 120px;
        }

        .input-phone {
          width: 12vw;
          min-width: 140px;
        }

        .form-select {
          width: 12vw;
          min-width: 140px;
        }

        .submit-button {
          background: linear-gradient(45deg, #ff7f00, #ff9600);
          color: white;
          font-weight: bold;
          font-size: 16px;
          border: none;
          padding: 10px 20px;
          width: 130px;
          height: 44px;
        }

        .agreement {
          font-size: 13px;
          color: white;
          display: flex;
          align-items: center;
        }

        @media (max-width: 800px) {
          .consultation-form {
            flex-direction: column;
            align-items: center;
          }

          .input-group {
            width: 100%;
            flex-direction: row;
          }

          .agreement,
          .submit-button {
            width: 100%;
          }
          .input-phone {
            width: 92%;
          }
          .fastPOST {
            display: none;
          }
        }

        @media (max-width: 768px) {
          .fastPOST {
            font-size: 14px;
          }

          .form-input,
          .form-select {
            font-size: 14px;
            height: 30px;
          }

          .submit-button {
            font-size: 14px;
            height: 38px;
          }
        }
      `}</style>
    </div>
  );
};

export default FixedConsultationForm;